import * as moment from 'moment';
import * as numeral from 'numeral/numeral';
import {SCMainData} from "../../supply-schedules/models/s-c-main-data";
import {TranslateType} from "../../shared/models/translateType";
import {Moment} from "moment";



export class Formatters {
    static maxAllowedDecimalPlaces = 5;

    //# convert datetime C# string to date if val is moment
    static dateFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L') : val) : '';

    //# convert datetime C# string to date if val is moment or string
    static dateFormatterConv = (row, cell, val): string =>
        val
            ? moment.isMoment(val)
                ? val.format('L')
                : moment.utc(val).format('L') !== 'Invalid date'
                    ? moment.utc(val).format('L')
                    : ''
            : '';

    static dateFormatterConvActionTab = (row, cell, val): string =>
        val === 'N/A'
            ? val
            : Formatters.dateFormatterConv(row, cell, val)

    //# convert datetime C# string to date if val is moment or string and splitter
    static multiDateFormatterConv = (row, cell, val): string =>{
        if (val === 'N/A'){
            return val
        } else if (val){
            let splited = val.split('/'),
                res: string = '';
            splited.forEach((s, i) => {
                res += i === 0 ? '' : '/'
                res += Formatters.dateFormatterConv(null, null, s)
                }
            )
            return res
        } else {
            return ''
        }
    }

    //# convert datetime C# string to dateTime string if val is moment
    static datetimeFormatter = (row, cell, val) => val ? (moment.isMoment(val) ? val.format('L LT') : val) : '';

    //# convert datetime C# string to Time string if val is moment
    static timeFormatter = (row, cell, val) => {
        return val ?
            moment.isMoment(val)
                ? val.format('LT')
                : moment.isDuration(val)
                    ? moment.utc(val.asMilliseconds()).format('LT')
                    : moment.utc(val).format('LT')
            : ''
    };

    static timeFormatter2 = (row, cell, val: number) => {
        return  val === null
            ? null
            : val < 10
                ? `0${val}:00`
                : `${val}:00`

    };

    //# convert datetime C# string to dateTime string if val is moment or string
    static dateTimeFormatterConv = (row, cell, val) => val ? moment.isMoment(val) ? val.format('DD.MM.YYYY HH:mm:ss') : moment.utc(val).format('DD.MM.YYYY HH:mm:ss') !== 'Invalid date' ? moment.utc(val).format('DD.MM.YYYY HH:mm:ss') : '' : '';

    //static numberFormatterTwoDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.00') : '';

    //static numberFormatterThreeDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.000') : '';

    //static numberFormatterFourDecimal = (row, cell, val) => val != null ? numeral(val).format('0,0.0000') : '';

    //static numberFormatterInteger = (row, cell, val) => val != null ? numeral(val).format('0,0') : '';

    static readonly checkedCssClass = 'fa-square-check';
    static readonly uncheckedCssClass = 'fa-square';

    //# convert boolean data aweasome icon checkbox
    static booleanFormatter = (row, cell, val) => `<i class="fa-regular ${val ? Formatters.checkedCssClass : Formatters.uncheckedCssClass}"></i>`;

    //# convert boolean data aweasome icon checkbox
    static booleanFormatterText = (row, cell, val, tr: string, fl: string) => `${val ? tr : fl}`;

    //# convert boolean data to checkbox
    static checkBoxFormatter = (row, cell, val, col?, dataContext?: any) => {
        // console.log(col, dataContext, 'checkBoxFormatter')

        return dataContext
            ? `<div class="out-chkb-wrp"><label class="chkb-wrp"><input class="chkb" type="checkbox" ${dataContext.disabled ? 'disabled': ''} ${val ? 'checked': ''}><span></span></label></div>`
            : `<div class="out-chkb-wrp"><label class="chkb-wrp"><input class="chkb" type="checkbox" ${val ? 'checked': ''}><span></span></label></div>`

    }

    //# convert num data to string with needed decimal
    static numberFormatter = (row: number, cell: number, val: any, decimalPlaces: number): string => {
        let res = parseFloat(val);
        return !isNaN(res)
            ? numeral(res).format(Formatters.getNumeralFormatString((res === 0 || res % 1 === 0) ? 0 : decimalPlaces))
            : val
    }

    //# convert num data to string with needed decimal
    static numberFormatterAuto = (row: number, cell: number, val: any) =>
        val != null
            ? parseFloat(val).toString()
            : '';

    //# convert num data to string, if conversion can be completed return string with needed decimal
    static numberCustomFormatter = (row: number, cell: number, val: any, decimalPlaces: number) => {
        let res = parseFloat(val);
        if (!isNaN(res)){
            if (res === 0){
                return res
            } else if (res % 1 === 0) {
                return res
            } else {
                return numeral(res).format(Formatters.getNumeralFormatString(decimalPlaces))
            }
        } else {
            return val
        }

    };

    //# return needed quantity of zeros
    static getNumeralFormatString = (decimalPlaces: number): string => {
        return `0,0${decimalPlaces > 0
            ? `.${new Array(Math.min(decimalPlaces, Formatters.maxAllowedDecimalPlaces) + 1).join('0')}`
            : ''}`;
    };

    //# format number to percent
    static percentFormatter = (row, cell, val): string => {
        return val ? `${Math.round(Number(val))}%` : val === 0 || val === '0' ? `${val}%` : '';
    };

    static stringCombinerFormatter = (row, cell, val, word, addText, container, translate, data, itemId): string => {
        if (!data) {
            return val;
        }

        let text = [];
        data.analogsWarning && ['analogCode1', 'analogCode2', 'analogCode3'].includes(itemId) && text.push(translate.AnalogsWarning);
        data.notMTSAtSomeWrhWarning1 && itemId === 'activeItems' && text.push(translate.NotMTSAtSomeWrhWarning1);
        data.partialSkuSupplierWarning1 && itemId === 'pricesCount' && text.push(translate.PartialSkuSupplierWarning1);
        data.notMTSAtSomeWrhWarning2 && itemId === 'activeItems' && text.push(translate.NotMTSAtSomeWrhWarning2);
        data.partialSkuSupplierWarning2 && itemId === 'pricesCount' && text.push(translate.PartialSkuSupplierWarning2);
        data.notPresentAtSomeWrhWarning && itemId === 'skuCode' && text.push(translate.NotPresentAtSomeWrhWarning);

        return `<span data-toggle="tooltip" data-html="true" data-container="${container}" title="${text.join('<br>')}">${val} ${word} ${addText}</span>`;
    };

    static translateFormatter = (row, cell, val, translate): string => {
        return `${translate[val]}`;
    };

    static IOHLineFormatter = (row, cell, val, translate): string => {
        switch (val){
            case 1: return translate['Transit']
            case 2: return translate['Cancel']
            case 3: return translate['Arrived']
        }
        return `${translate[val]}`;
    };

    static Activity = (row, cell, val): string => {
        switch (val){
            case 0: return 'OLD'
            case 1: return 'MTS'
            case 2: return 'MTO'
            case 3: return 'OUT'
        }
        return `${val}`;
    };

    //# format edit sell for scheduled grid
    static formatSelectCell = (row, cell, val, translates): string => {
        return `<div style="position: relative" class="format-edit-cell">
                    <span style="width: calc(100% - 14px); display: inline-block; overflow: hidden; text-overflow: ellipsis;">${val ? val : ''}</span>
                    <span class="fa-solid fa-pencil" style="position: absolute; top: 4px; right: -3px; cursor: pointer; font-size: 14px" data-toggle="tooltip" title="${translates['Edit']}" style="cursor: pointer"></span>
                </div>`;
    };

    static formatShowCell = (row, cell, val, translates): string => {
        return `<div style="position: relative" class="format-edit-cell">
                    <span style="width: calc(100% - 14px); display: inline-block; overflow: hidden; text-overflow: ellipsis;">${val ? val : ''}</span>
                    <span class="fa-solid fa-eye" style="position: absolute; top: 4px; right: -3px; cursor: pointer; font-size: 14px" data-toggle="tooltip" title="${translates['Show']}" style="cursor: pointer"></span>
                </div>`;
    };

    static formatObjArr = (row, cell, val): string => {
        return val && val.length ? val.length.toString() : '0';
    };

    static customParseNumber = (val: string): number => {
        if (val === ''){
            return null;
        }
        let tmp = Number(val)
        return Number.isNaN(tmp) ? null : tmp;
    }

     static yesNo = (row, cell, val: any, translate: {[key: string] : string}): string => {
        return val ? translate.Yes : translate.No;
     }

    static sc = {
        supplyType: (row, cell, val: number, translate): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
                switch (val){
                    case 0: return translate.SC_Outer;
                    case 1: return translate.SC_Inner;
                    default: return !val ? '' : val.toString();
                }
            },
        scheduleCycleType: (row, cell, val, translate): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 1: return translate.SC_ByWeekDays;
                case 2: return translate.SC_DayOfMonth;
                case 3: return translate.SC_DayOfTheMonth;
                default: return !val ? '' : val.toString();
            }
        },
        weekday: (row, cell, val: string, translate): string => {
            switch (val){
                case '1': return translate.MondayShort;
                case '2': return translate.TuesdayShort;
                case '3': return translate.WednesdayShort;
                case '4': return translate.ThursdayShort;
                case '5': return translate.FridayShort;
                case '6': return translate.SaturdayShort;
                case '7': return translate.SundayShort;
                case 'NoSchedule': return translate.NoSchedule;
                default: return val === null || !val ? '' : val.toString();
            }
        },
        weekdayLong: (row, cell, val: string, translate): string => {
            switch (val){
                case '1': return translate.Monday;
                case '2': return translate.Tuesday;
                case '3': return translate.Wednesday;
                case '4': return translate.Thursday;
                case '5': return translate.Friday;
                case '6': return translate.Saturday;
                case '7': return translate.Sunday;
                case 'NoSchedule': return translate.NoSchedule;
                default: return val === null || !val ? '' : val.toString();
            }
        },
        weekdayProp: (val: number): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 1: return 'monday';
                case 2: return 'tuesday';
                case 3: return 'wednesday';
                case 4: return 'thursday';
                case 5: return 'friday';
                case 6: return 'saturday';
                case 7: return 'sunday';
                default: return val === null || !val ? '' : val.toString();
            }
        },

        weekdayForWeekDayTable: (row, cell, val: number, translate): string => {
            if (val > 7){
                val = val - Math.trunc(val / 7) * 7;
                val = val === 0 ? val + 7 : val ;
            }
            let res: string;
            switch (val){
                case 0: res = null; break;
                case 1: res = translate.MondayShort; break;
                case 2: res = translate.TuesdayShort; break;
                case 3: res = translate.WednesdayShort; break;
                case 4: res = translate.ThursdayShort; break;
                case 5: res = translate.FridayShort; break;
                case 6: res = translate.SaturdayShort; break;
                case 7: res = translate.SundayShort; break;
                default: res = !val ? '' : val.toString();
            }
            return res;
        },

        scheduleType: (row, cell, val: number, translate): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 0: return translate.SC_Persistent;
                case 1: return translate.SC_Temporary;
                default: return !val ? '' : val.toString();
            }
        },
        scheduleParamTable: (row, cell, val: number): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 0: return '';
                default: return !val ? '' : val.toString();
            }
        },

        deliveryType: (row, cell, val: number, translate): string =>{
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 0: return translate.SC_DirectDeliveries;
                case 1: return translate.SC_NonFresh;
                case 2: return translate.SC_PBL;
                default: return !val ? '' : val.toString();
            }
        },
        itemType: (row, cell, val, translate): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            }
            switch (val){
                case 0: return translate.SC_Fresh;
                case 1: return translate.SC_NonFresh;
                case 2: return translate.SC_FreshNonFresh;
                default: return !val ? '' : val.toString();
            }
        },
        time: (row, cell, val): string => {
            if (typeof val === 'string'){
                val = Formatters.customParseNumber(val)
            } else if (!val){
                return ''
            }
            return moment.utc(val*3600*1000).format('HH:mm')
        },
        forEmptyName: (row, cell, val, column, item: SCMainData, noSchedule: string): string => {
            return  item.Monday === noSchedule
                ? ''
                : val
        },
        forEmptyDate: (row, cell, val, column, item: SCMainData, noSchedule: string): string => {
            return  item.Monday === noSchedule
                ? ''
                : Formatters.dateTimeFormatterConv(row, cell, val)
        },
        forEmptyScheduleNumber: (row, cell, val, column, item: SCMainData, scheduleForDelete: number): string => {
            return  item.OrderScheduleNumber === scheduleForDelete
                ? ''
                : val
        },

    }
    //# format registry type for buffertable module
    static registryBT = (row, cell, val, translates: {[key : string] : string}): string => {
        return val === 'Fresh2' ? translates.Fresh2 : translates.NonFresh;
    };

    static icons = {
        eyeCell: (row, cell, val, translates: {[key : string] : string}): string => {
            return '<span class="fa fa-eye fa-fw" data-toggle="tooltip" title="' + translates['Show'] + '" style="cursor: pointer"></span>';
        }
    }

    static vcCancel = (row, cell, val, translates: {[key : string] : string}): string => {
        return  val ? translates['Canceled'] : ''
        // switch (val){
        //     case 0: return ''
        //     case 1: return translates['Cancel']
        // }
    };

    //# convert time int to time
    static timeNumberFormatter = (row, cell, val: number): string => {
        if (val){
            return val < 10 ? '0' + val.toString() + ':00' : val + ':00'
        } else {
            return ''
        }

    }

    //# Orders planArriveDate formatter
    static planArriveDateFormatter = (row, cell, val: Moment, translates: TranslateType): string => {
        // return `<span>FRESH: ${this.salesPeriod.fresh} ${this.translates['Days']}</span>`
        let title: string,
            date = val.clone().local().startOf('day');

        const now = moment().startOf('day');
        if (date.isBefore(now)){
            title = translates['Orders_OrderWasLate']
        } else if (date.isSame(now)){
            title = translates['Orders_OrderComeToday']
        } else if (date.isAfter(now)){
            title = translates['Orders_OrderDateComeLater']
        }

        return `<span data-toggle="tooltip" data-html="true" data-container="#orders-module" title="${title}">${Formatters.datetimeFormatter(row, cell, val)}</span>`
    };
}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/formatters.ts